import { PushNotificationService } from 'common/services';
import { SoundName } from 'features/audio-player/enums';
import { AudioPlayer } from 'features/audio-player/services';

export const notifyAboutIncomingCall = (ringtone = SoundName.RINGING) => {
  AudioPlayer.play(ringtone);
  PushNotificationService.getInstance().createCallNotification();
};
